import styled, { css } from 'styled-components';

interface MobileProps {
	isMobile?: boolean;
}

export const Base = styled.div`
	position: relative;
	display: inline-flex;
	flex-direction: column;
	margin-top: 8px;
	margin-bottom: 8px;
	padding-right: 8px;
`;

interface ButtonProps extends MobileProps {
	$hasDetail?: boolean;
	$disabled?: boolean;
	$queued?: boolean;
}

export const Button = styled.div<ButtonProps>`
	display: inline-flex;
	align-items: center;
	gap: 10px;
	padding: 8px 16px;
	padding-right: 20px;
	background-color: ${({ theme, $queued }) => ($queued ? theme.gray[200] : theme.gray[100])};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	font-size: ${({ isMobile }) => (isMobile ? '16px' : '13px')};
	color: ${({ theme, $disabled, $queued }) =>
		$disabled || $queued ? theme.gray[600] : theme.gray[900]};
	transition: background-color 0.15s ease, border-color 0.15s ease;
	user-select: none;
	cursor: default;

	${({ $hasDetail }) =>
		$hasDetail
			? css`
					border-radius: 18px 18px 0 0;
			  `
			: css`
					border-radius: 18px;
			  `}

	${({ $disabled, $queued }) =>
		!$disabled &&
		!$queued &&
		css`
			&:hover {
				background-color: ${({ theme }) => theme.gray[200]};
				border-color: ${({ theme }) => theme.blue[500]};
			}
		`}
`;

export const IconWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const Label = styled.div`
	flex: 1;
	font-weight: 500;
	line-height: 1.4;
`;

export const Detail = styled.div<MobileProps>`
	padding: 8px 14px 10px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-top: none;
	border-radius: 0 0 18px 18px;
	font-size: ${({ isMobile }) => (isMobile ? '14px' : '11px')};
	color: ${({ theme }) => theme.gray[600]};
	line-height: 1.5;
	cursor: default;
`;

export const DetailContent = styled.div<{ $expanded?: boolean }>`
	${({ $expanded }) =>
		!$expanded &&
		css`
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		`}
`;

export const DetailActions = styled.div`
	position: absolute;
	bottom: 6px;
	right: 6px;
	display: flex;
	gap: 4px;
	align-items: center;
	opacity: 0;
	transition: opacity 0.1s ease;
	background: ${({ theme }) => theme.gray[100]};
	border-radius: 6px;

	${Base}:hover & {
		opacity: 1;
	}
`;

export const DetailButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	padding: 8px 7px;
	border-radius: 6px;
	border: none;
	background: ${({ theme }) => theme.gray[200]};
	color: ${({ theme }) => theme.gray[600]};
	font-size: 11px;
	font-family: inherit;
	transition: background 0.15s;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;
